import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import ImageLoader from '../../common/ImageLoader/ImageLoader';


const CourseItem = ({slug, title, description, image}) => {
  return (
    <Link to={`/kurzus/${slug}`} className="course-item">
      <ImageLoader src={image.medium || image.full} alt={title} className="course-item__image" />
      <h3 className="course-item__title">{title}</h3>
      <div className="course-item__description">{description.short}</div>
    </Link>
  );
};


CourseItem.propTypes = {
  slug: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.object.isRequired,
  image: PropTypes.object.isRequired
};

export default CourseItem;



// WEBPACK FOOTER //
// ./src/components/Home/Courses/CourseItem.js